export enum ProductDetailsDeliverySettings {
  CLIENT_SIDE = 'client_side',
  NAME = 'pdp_delivery_settings_rendering',
  SERVER_SIDE = 'server_side',
}
